define(function (require) {
	const tpl = require('./t_lov_setup.hbs');
	const ccn = require('../../core_constants');
	const view_manager = require('civicsUtils/view_manager');
	const modal_region = require('civicsUtils/modal_region');
	const twoFactorUtility = require('../2fa_utility');
	const mfa_subscription_model = require('civicsModels/mfa_subscription_model');
	
	return Marionette.LayoutView.extend({
		className:'v-lov-factor-authentication-setup-modal',
		template: tpl,
		regions: {
			modalRegion: {
				regionClass: modal_region,
				selector: 'body .rhythm-modals'
			},
			confirmationRegion: {
				selector: '.confirmation-modal-container', // Add a sub-region
			}
		},
		ui:{
			closeModalButton:'.close-modal',
			closeModalXButton:'.bbm-btn-close',
			submitButton:'.submit-setup',
			selectMethod:'.method-preference',
			confirmationModalContaienr: '.confirmation-modal-container'
		},
		events: {
			'click @ui.closeModalButton':'closeModal',
			'click @ui.closeModalXButton':'closeModal',
			'click @ui.submitButton':'submitClicked'
		},
		initialize: function (options) {
			this.options = options;
			this.config = options.config || {};
			this.config.globalConfig = view_manager.globalConfig().toJSON();
			this.model = new Backbone.Model();
			this.processAvailableFactors();
		},
		onShow: function () {
			//this.ui.selectMethod.find('input').focus();
		},
		onRender:function(){
			this.$el.rhythmThemeInit();
     		this.$el.rhythmThemeInitCivics();
		},
		processAvailableFactors:function(){
			//we need to split out the available factors that are not available because they don't have details.
			//This function should result in two arrays - one of available factors, and one of unavailable factors
			let available = [];
			let unavailable = [];
			if(this.options.settings.availableFactors && this.options.settings.availableFactors.length>0){
				available = this.options.settings.availableFactors.filter(factor=>factor.details!=null && factor.details.trim().length!=0);
				unavailable = this.options.settings.availableFactors.filter(factor=>factor.details==null || factor.details.trim().length==0);	
				unavailable.forEach(factor=>factor.displayText = i18n.t('CIVICS.LOGIN.FACTOR_AUTH.SETUP_'+factor.notificationMethod.toUpperCase()+'_FACTOR_UNAVAILABLE'));
			}
			this.model.set('availableFactors',available);
			this.model.set('unavailableFactors',unavailable);
		},
		closeModal:function(e){
			e.stopPropagation();
			e.stopImmediatePropagation();
			e.preventDefault();
			if (this.config.globalConfig.mfaEnforced && App.localStorage.get('CIVICS', 'REQUIRES_MFA_ENROLLMENT')) {
				// Remove hidden class of this container so we can show the confirmation modal in this.showChildView()
				this.ui.confirmationModalContaienr.removeClass('hidden');

				let twoFactorUtil = twoFactorUtility({ modalRegion: this.getRegion('modalRegion') });
				let confirmCloseMFASetup = twoFactorUtil.showMFASetupSkipConfirmation(this.onConfirmClose.bind(this));
				this.showChildView('confirmationRegion', confirmCloseMFASetup);
			return false;
			} else {
				this.options.setupAuthenticationPromise.reject();
				this.destroy();
			}
			
		},
		onConfirmClose:function(e) {
			view_manager.loading(true);
			if (e) {
				e.stopPropagation();
				e.preventDefault();
			}
			// Clean up event listener and flags
			App.localStorage.remove('CIVICS', 'REQUIRES_MFA_ENROLLMENT');
			window.location.href = '/c/portal/logout';
		},
		submitClicked:function(e){
			if(e){
				e.stopPropagation();
				e.preventDefault();
			}
			this.ui.submitButton.prop('disabled',true);
			let method = this.getSelectedAuthenticationMethod();
			if(method){//only exists if view validated
				this.saveAuthenticationMethod(method);
			} else {//enable the button since the view didin't validate
				this.ui.submitButton.prop('disabled',false);
			}
		},
		getSelectedAuthenticationMethod:function(){
			if(view_manager.validatePageControl(this.$el)){
				let data = Backbone.Syphon.serialize(this.$el);

				return this.model.get('availableFactors').find(element=>element.notificationMethod == data.selectedMethod);
			} 
			return null;
		},
		saveAuthenticationMethod:function(data){
			let mfaSubModel = new mfa_subscription_model(data);
			view_manager.loading(true);
			mfaSubModel.save().done((response)=>{
				//we should never get here.
				console.log('Something went wrong setting up MFA.')
			}).fail((response)=>{
				if(response.status == 403 &&
					response.responseJSON && 
					response.responseJSON.data &&
					response.responseJSON.data.mfaStatus.toLowerCase() == ccn.NOTIFIED){
				this.saveAuthenticationMethodSuccessful(response,mfaSubModel)
				} else {
					view_manager.errorToWindow(response);
					this.ui.submitButton.prop('disabled',false);
				}
			}).always(()=>{
				view_manager.loading(false);
			})

		},
		saveAuthenticationMethodSuccessful:function(response,mfaSubModel){
			//for some reason I can't pass the response and mfaSubModel directly. 
			//has to be wrapped in an object and I don't know why.
			this.options.setupAuthenticationPromise.resolve({
				response:response,
				originalModel:mfaSubModel
			});
		},
		templateHelpers: function () {
			return {
				factorsAvailable:this.model.get('availableFactors').length > 0,
				selectedMethod:this.model.get('availableFactors').length == 1 ? this.model.get('availableFactors')[0].providerType : null,
				enforcedMFA: this.config.globalConfig.mfaEnforced
			};
		}
	});
});
